import { type To } from "react-router-dom";
import { SourcingEventStatus } from "../../autogen/bff-api";
import { urls } from "../../urls";

export const procurementEntryHref = (_status: SourcingEventStatus, id: string): To =>
  urls.app.sourcingEvents.view.go(id);
